import Vue from 'vue'
import Vuex from 'vuex'
import cifuri from './cifuri'
import clasificatie from './clasificatie'
import indicatori from './indicatori'
import verificare from './verificare'
import date from './date'
import users from './users'
import dictionar from './dictionar'

import uniqid from 'uniqid'

import judete from './judete'
import municipii from './municipii'
import orase from './orase'
import comune from './comune'
import all from './all'
import adminmaps from './adminmaps'
import verificareApl from './verificare-apl'
import municipiiClient from './municipii-client'
import oraseClient from './orase-client'
import judeteClient from './judete-client'
import comuneClient from './comune-client'
import hartiClient from './harti-client'
import agregate from './agregate'
import lists from './lists'
import rapoarte from './rapoarte'
import access from './access'
import clasificatiecheck from './clasificatiecheck'
import automation from './automation'
import mfdata from './mfdata'
import storage from './storage'

import feathers from '@/feathers/'
import _debounce from 'lodash.debounce'
import SERVER_URL from '@/config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    automation,
    mfdata,
    storage,
    cifuri,
    clasificatie,
    indicatori,
    verificare,
    date,
    users,
    judete,
    municipii,
    orase,
    comune,
    verificareApl,
    municipiiClient,
    oraseClient,
    judeteClient,
    lists,
    rapoarte,
    access,
    clasificatiecheck,
    dictionar,
    comuneClient,
    all,
    agregate,
    adminmaps,
    hartiClient
  },
  state: {
    host: SERVER_URL,
    serverStats: null,
    poolData: null,
    loading: false,
    auth: {
      user: null,
      token: null
    },
    log: {
      limit: 10,
      page: 1,
      open: false,
      items: [],
      filter: 'toate'
    },
    feathers,
    services: {
      users: feathers.service('users'),
      userheaders: feathers.service('userheaders'),
      logs: feathers.service('logs'),
      'users-upload': feathers.service('users-upload'),
      cifuri: feathers.service('cifuri'),
      cifuriheaders: feathers.service('cifuriheaders'),
      cifuriperioade: feathers.service('cifuriperioade'),
      'cifuri-upload': feathers.service('cifuri-upload'),
      clasificatie: feathers.service('clasificatie'),
      clasificatieheaders: feathers.service('clasificatieheaders'),
      'clasificatie-upload': feathers.service('clasificatie-upload'),
      indicatori: feathers.service('indicatori'),
      indicatoriheaders: feathers.service('indicatoriheaders'),
      'indicatori-upload': feathers.service('indicatori-upload'),
      verificare: feathers.service('verificare'),
      verificareheaders: feathers.service('verificareheaders'),
      'verificare-upload': feathers.service('verificare-upload'),
      date: feathers.service('date'),
      dateheaders: feathers.service('dateheaders'),
      'date-upload': feathers.service('date-upload'),
      computation: feathers.service('computation'),
      'computes-formulas': feathers.service('computes-formulas'),
      'delete-worker': feathers.service('delete-worker'),

      lists: feathers.service('lists'),
      listsheaders: feathers.service('listsheaders'),
      'lists-upload': feathers.service('lists-upload'),

      rapoarte: feathers.service('rapoarte'),
      rapoarteheaders: feathers.service('rapoarteheaders'),

      reports: feathers.service('reports'),

      access: feathers.service('access'),
      accessheaders: feathers.service('accessheaders'),

      clasificatiecheck: feathers.service('clasificatiecheck'),
      clasificatiecheckheaders: feathers.service('clasificatiecheckheaders'),

      automation: feathers.service('automation'),
      automationheaders: feathers.service('automationheaders'),

      mfdata: feathers.service('mfdata'),
      mfdataheaders: feathers.service('mfdataheaders'),

      storage: feathers.service('storage'),
      storageheaders: feathers.service('storageheaders'),

      dictionary: feathers.service('dictionary'),
      dictionaryheaders: feathers.service('dictionaryheaders'),
      'dictionary-upload': feathers.service('dictionary-upload'),
      'adminmaps': feathers.service('adminmaps'),
      'adminmapsheaders': feathers.service('adminmapsheaders'),

      'robodownloader': feathers.service('robodownloader')
    }
  },
  getters: {
    host: state => state.host,
    loading: state => state.loading,
    user: state => state.auth.user,
    token: state => state.auth.token,
    log: state => state.log,
    serverStats: state => state.serverStats,
    poolData: state => state.poolData
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setUser (state, payload) {
      Vue.set(state.auth, 'user', payload)
    },
    setToken (state, payload) {
      Vue.set(state.auth, 'token', payload)
    },
    addMessage (state, payload) {
      state.log.items.splice(0, 0, payload)
    },
    closeMessages (state) {
      state.log.open = false
    },
    openMessages (state) {
      state.log.open = true
    },
    setLogItems (state, payload) {
      state.log.items = payload.data
      state.log.pages = Math.ceil(payload.total / state.log.limit)
      if (!state.auth.user || !state.auth.user.logclosed) {
        state.log.open = true
      }
    },
    setLogPage (state, payload) {
      state.log.page = payload
    },
    deleteMessage (state, payload) {
      state.log.items = state.log.items.filter(item => item._id !== payload)
    },
    setLogFilter (state, payload) {
      Vue.set(state.log, 'filter', payload)
    },
    resetLog (state) {
      Vue.set(state, 'log', {
        limit: 10,
        page: 1,
        open: false,
        items: [],
        filter: 'toate'
      })
    },
    setServerStats (state, payload) {
      Vue.set(state, 'serverStats', payload)
    },
    setPoolData (state, payload) {
      Vue.set(state, 'poolData', payload)
    }
  },
  actions: {
    setEventWatchers ({ dispatch, state }) {
      state.services.logs.events.forEach(event => {
        state.services.logs.on(event, data => {
          dispatch('fetchLog')
        })
      })
      state.services.logs.on('batchDeleteSuccess', data => {
        dispatch('fetchLog')
      })
    },
    async login ({ commit, dispatch }, data) {
      commit('setLoading', true)

      feathers.on('reauthentication-error', err => {
        console.log('reauthentication-error: ', err)
      })

      let auth = null
      let storedToken = null

      if (data) {
        auth = feathers.authenticate({
          strategy: 'local',
          email: data.email,
          password: data.password
        })
      } else {
        storedToken = localStorage.getItem('anl-auth')
        if (storedToken) {
          auth = feathers.reAuthenticate()
        }
      }

      let user = null
      let token = null

      if (auth) {
        return auth.then(response => {
          user = response.user
          token = response.accessToken
          dispatch('setEventWatchers')
          dispatch('saveMessage', {
            user: user._id,
            text: `Autentificare reusita! Bine ai venit, ${user.username}!`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'info'
          })
          commit('setUser', user)
          commit('setToken', token)
          commit('setLoading', false)
          return Promise.resolve(user)
        }).catch(error => {
          dispatch('logout')
          commit('addMessage', {
            _id: uniqid(),
            text: error.name === 'NotAuthenticated' ? 'Autentificare esuata. Date invalide...' : error.message,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error',
            local: true
          })

          return Promise.reject(new Error('Date de autentificare invalide...'))
        })
      } else {
        return Promise.reject(new Error('Nu exista token. Folositi formularul de logare.'))
      }
    },
    async logout ({ state, commit, dispatch }) {
      if (state.auth.user) {
        // await dispatch('clearMessages')
        commit('resetLog')
      }

      try {
        await feathers.logout()
      } catch (error) {
        console.log(error)
        localStorage.removeItem('anl-auth')
      }

      return commit('setUser', null)
    },
    saveMessage ({ state }, payload) {
      state.services.logs.create(payload)
        .catch(error => {
          console.log(error)
        })
    },
    fetchLog: _debounce(({ commit, state }) => {
      if (state.auth.user) {
        const query = {
          user: state.auth.user._id,
          $limit: state.log.limit,
          $skip: state.log.limit * (state.log.page - 1),
          $sort: {
            _id: -1
          }
        }

        if (state.log.filter !== 'toate') {
          query.type = state.log.filter
        }

        return state.feathers.services.logs.find({ query }).then(result => {
          commit('setLogItems', result)
        })
      }
    }, 1000),
    deleteMessage ({ state, commit }, payload) {
      const message = state.log.items.find(msg => msg._id === payload)
      if (message) {
        if (message.local) {
          commit('deleteMessage', payload)
        } else {
          state.services.logs.remove(payload, {
            query: {
              user: state.auth.user._id
            }
          })
        }
      }
    },
    clearMessages ({ state, dispatch }, payload) {
      dispatch('saveMessage', {
        user: state.auth.user._id,
        text: `Incepe stergerea log-ului. Operatiune ce poate dura.`,
        timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        type: 'info'
      })
      let query = {
        user: state.auth.user._id
      }

      if (payload !== 'toate') {
        query.type = payload
      }

      return state.services['delete-worker'].remove({ query, service: 'logs' })
    },
    setLogPage ({ commit, dispatch }, payload) {
      commit('setLogPage', payload)
      dispatch('fetchLog')
    },
    toggleLog ({ state, commit, dispatch }, payload) {
      state.services.users.patch(state.auth.user._id, {
        logclosed: payload
      }).then(result => {
        commit('setUser', result)
        return dispatch('saveMessage', {
          user: state.auth.user._id,
          text: `Stare log schimbata: deschidere ${!payload ? 'automata' : 'manuala'}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changeLogFilter ({ commit, dispatch }, payload) {
      commit('setLogFilter', payload)
      dispatch('fetchLog')
    },

    async getServerStats ({ state, commit }) {
      try {
        const serverStats = await fetch(
          `${state.host}/rest-getinfo`,
          {
            headers: new Headers({
              'Authorization': state.auth.token
            })
          }
        )

        if (serverStats.status >= 200 && serverStats.status < 300) {
          const serverStatsJson = await serverStats.json()

          commit('setServerStats', serverStatsJson)
        } else {
          throw new Error(serverStats.statusText)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getPoolData ({ state, commit }) {
      try {
        const poolData = await fetch(
          `${state.host}/pool-data`,
          {
            headers: new Headers({
              'Authorization': state.auth.token
            })
          }
        )

        if (poolData.status >= 200 && poolData.status < 300) {
          const poolDataJson = await poolData.json()

          commit('setPoolData', poolDataJson)
        } else {
          throw new Error(poolData.statusText)
        }
      } catch (err) {
        console.log(err)
      }
    },

    recomputeAll ({ state }, payload) {
      state.services.computation.update(null, {
        query: {
          type: 'everyone!!!',
          tip_apl: payload
        }
      })
    },
    recomputeAllPerioada ({ state }, payload) {
      state.services.computation.update(null, {
        query: {
          type: 'perioada',
          tip_apl: payload.type,
          id_perioada: payload.idPerioada
        }
      })
    },

    async destoryPool ({ state, dispatch }, payload) {
      try {
        dispatch('date/destroyMassiveUploadPool')

        await fetch(
          `${state.host}/pool-destory`,
          {
            method: 'POST',
            headers: new Headers({
              'Authorization': state.auth.token,
              'Content-Type': 'application/json'
            }),
            body: JSON.stringify({ pool: payload })
          }
        )
      } catch (err) {
        console.log(err)
      }
    }
  }
})
